module.exports = __webpack_public_path__ + "img/Group 361.8b0a542e.png";